import { createBrowserRouter } from "react-router-dom";
import Home01Layout from "../Layout/Home01Layout";
import Home02Layout from "../Layout/Home02Layout";
import About from "../Pages/About";
import BlogClassic from "../Pages/BlogPages/BlogClassic";
import BlogDetails from "../Pages/BlogPages/BlogDetails";
import BlogGrid from "../Pages/BlogPages/BlogGrid";
import BlogSlide from "../Pages/BlogPages/BlogSlide";
import BlogStandard from "../Pages/BlogPages/BlogStandard";
import Contact01 from "../Pages/ContactPages/Contact01";
import Contact02 from "../Pages/ContactPages/Contact02";
import Gallery from "../Pages/Gallery";
import Home from "../Pages/HomePages/Home";
import Home02 from "../Pages/HomePages/Home02";
import Menu01 from "../Pages/MenuPages/Menu01";
import Menu02 from "../Pages/MenuPages/Menu02";
import Menu03 from "../Pages/MenuPages/Menu03";
import ErrorPage from "../Pages/Shared/ErrorPage";
import Cart from "../Pages/ShopPages/Cart";
import CheckOut from "../Pages/ShopPages/CheckOut";
import Shop3Col from "../Pages/ShopPages/Shop3Col";
import Shop4Col from "../Pages/ShopPages/Shop4Col";
import SingleProduct from "../Pages/ShopPages/SingleProduct";
import Team from "../Pages/Team";

export const routes = createBrowserRouter([
    {
        path: "/",
        element: <Home01Layout/>,
        children: [
            {
                path: '/',
                element: <Home/>
            },
            {
                path: '/about',
                element: <About/>
            },
            
            {
                path: '/menu1',
                element: <Menu01/>
            },
            {
                path: '/menu2',
                element: <Menu02/>
            },
            {
                path: '/menu3',
                element: <Menu03/>
            },
            {
                path: '/team',
                element: <Team/>
            },
            {
                path: '/gallery',
                element: <Gallery/>
            },
            {
                path: '/shop-3col',
                element: <Shop3Col/>
            },
            {
                path: '/shop-4col',
                element: <Shop4Col/>
            },
            {
                path: '/single-product',
                element: <SingleProduct/>
            },
            {
                path: '/cart',
                element: <Cart/>
            },
            {
                path: '/checkout',
                element: <CheckOut/>
            },
            {
                path: '/blog-standard',
                element: <BlogStandard/>
            },
            {
                path: '/blog-classic',
                element: <BlogClassic/>
            },
            {
                path: '/blog-grid',
                element: <BlogGrid/>
            },
            {
                path: '/blog-details',
                element: <BlogDetails/>
            },
            {
                path: '/blog-details-with-sidebar',
                element: <BlogSlide/>
            },
            {
                path: '/contact1',
                element: <Contact01/>
            },
            {
                path: '/contact2',
                element: <Contact02/>
            },
            {
                path: '*',
                element: <ErrorPage/>
            },

        ]
    },
    {
        path: "/home-2",
        element: <Home02Layout/>,
        children: [
            {
                path: '/home-2',
                element: <Home02/>
            },
            // {
            //     path: '/about',
            //     element: <About/>
            // },
            
            // {
            //     path: '/menu1',
            //     element: <Menu01/>
            // },
            // {
            //     path: '/menu2',
            //     element: <Menu02/>
            // },
            // {
            //     path: '/menu3',
            //     element: <Menu03/>
            // },
            // {
            //     path: '/team',
            //     element: <Team/>
            // },
            // {
            //     path: '/gallery',
            //     element: <Gallery/>
            // },
            // {
            //     path: '/shop-3col',
            //     element: <Shop3Col/>
            // },
            // {
            //     path: '/shop-4col',
            //     element: <Shop4Col/>
            // },
            // {
            //     path: '/single-product',
            //     element: <SingleProduct/>
            // },
            // {
            //     path: '/cart',
            //     element: <Cart/>
            // },
            // {
            //     path: '/checkout',
            //     element: <CheckOut/>
            // },
            // {
            //     path: '/blog-standard',
            //     element: <BlogStandard/>
            // },
            // {
            //     path: '/blog-classic',
            //     element: <BlogClassic/>
            // },
            // {
            //     path: '/blog-grid',
            //     element: <BlogGrid/>
            // },
            // {
            //     path: '/blog-details',
            //     element: <BlogDetails/>
            // },
            // {
            //     path: '/blog-details-with-sidebar',
            //     element: <BlogSlide/>
            // },
            // {
            //     path: '/contact1',
            //     element: <Contact01/>
            // },
            // {
            //     path: '/contact2',
            //     element: <Contact02/>
            // },
            {
                path: '*',
                element: <ErrorPage/>
            },

        ]
    }
])